module.exports = __webpack_public_path__ + "img/p9.80e48682.png";